
import React from 'react';
import { BarChart3 } from 'lucide-react';

const WaterEquipmentHealth = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="p-4 flex flex-col items-center justify-center h-full w-full">
        <h3 className="text-lg font-medium text-gray-800 dark:text-white mb-2">Equipment Health</h3>
        <div className="mb-2">
          <BarChart3 className="h-7 w-7 text-blue-500 mb-2" />
        </div>
        <div className="w-full space-y-1">
          <div className="flex justify-between text-xs">
            <span>Pumps</span>
            <span className="text-green-400">95%</span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1">
            <div className="bg-green-500 h-1 rounded-full" style={{ width: '95%' }}></div>
          </div>
          
          <div className="flex justify-between text-xs">
            <span>Valves</span>
            <span className="text-green-400">93%</span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1">
            <div className="bg-green-500 h-1 rounded-full" style={{ width: '93%' }}></div>
          </div>
          
          <div className="flex justify-between text-xs">
            <span>Meters</span>
            <span className="text-yellow-400">88%</span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1">
            <div className="bg-yellow-500 h-1 rounded-full" style={{ width: '88%' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaterEquipmentHealth;
